var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.5C12.5523 22.5 13 22.0523 13 21.5L13 3.5C13 2.94772 12.5523 2.5 12 2.5C11.4477 2.5 11 2.94772 11 3.5L11 21.5C11 22.0523 11.4477 22.5 12 22.5Z",
    fill: "#12131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 22.2071C11.6834 22.5976 12.3166 22.5976 12.7071 22.2071L19.7071 15.2071C20.0976 14.8166 20.0976 14.1834 19.7071 13.7929C19.3166 13.4024 18.6834 13.4024 18.2929 13.7929L12 20.0858L5.70711 13.7929C5.31658 13.4024 4.68342 13.4024 4.29289 13.7929C3.90237 14.1834 3.90237 14.8166 4.29289 15.2071L11.2929 22.2071Z",
    fill: "#12131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLine);
export default __webpack_public_path__ + "static/media/arrow-down-line.f4a64cb8eabac8250208a8bfd1f95552.svg";
export { ForwardRef as ReactComponent };